import Option from "@JohnLewisPartnership/jl-design-system/dist/components/option/Option";
import { useRef, useState } from "react";
import { SaleTagIcon } from "../../__shared__/SaleTagIcon/SaleTagIcon";
import { IconButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/IconButton";
import { InfoOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/InfoOutlined";
import { CloseOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/CloseOutlined";
import styles from "./DeliveryServiceItem.module.scss";

type Props = {
  checked: boolean;
  description: string;
  disabled: boolean;
  display: string;
  serviceId: string;
  title: string;
  toggleCheck: (serviceId: string) => void;
  value: number;
  key: string;
  showFreeServicePromoTag: boolean;
};

export const DeliveryServiceItem = ({
  checked,
  description,
  disabled,
  display,
  serviceId,
  title,
  toggleCheck,
  value,
  key,
}: Props) => {
  const [showInfo, setShowInfo] = useState(false);
  const infoButtonRef = useRef<HTMLButtonElement>(null);
  const isFree = value === 0;

  const handleTooltipExpandClick = () => {
    setShowInfo(!showInfo);
    infoButtonRef.current?.focus();
  };
  const handleTooltipCollapseClick = () => setShowInfo(false);
  const handleToggleCheckClick = () => toggleCheck(serviceId);

  const freeLabel = (
    <div
      className={styles.tagBadge}
      data-testid="product:delivery-service:free-badge"
    >
      <SaleTagIcon type="small" />
      <p>Free</p>
    </div>
  );

  return (
    <div
      id="product:delivery-service"
      data-testid="product:delivery-service"
      className={styles.deliveryServiceItemWrapper}
    >
      <div className={styles.serviceItem}>
        <Option
          type="checkbox"
          isControlled={true}
          className={styles.serviceInfo}
          id={serviceId}
          ariaLabel={title}
          label={title}
          checked={checked}
          onClick={handleToggleCheckClick}
          name={title}
          value={""}
          additionalInfo={isFree ? freeLabel : display}
          disabled={disabled}
        />
        <IconButton
          IconComponent={InfoOutlined}
          ariaLabel={`${title} information`}
          data-testid="product:delivery-service:tooltip:button:expand"
          ref={infoButtonRef}
          onClick={handleTooltipExpandClick}
          className={styles.serviceToolTip}
          aria-expanded={showInfo}
          aria-controls={key}
          variant="clear-light"
        />
      </div>
      <div
        id={key}
        data-testid="product:delivery-service:tooltip"
        className={styles.infoBlock}
        hidden={!showInfo}
      >
        <div aria-live="polite" className={styles.tip}>
          <h4 className={styles.title}>{title}</h4>
          <div dangerouslySetInnerHTML={{ __html: `${description}` }} />
        </div>
        <IconButton
          IconComponent={CloseOutlined}
          ariaLabel={"Collapse tooltip"}
          data-testid="product:delivery-service:tooltip:button:collapse"
          className={styles.closeButton}
          onClick={handleTooltipCollapseClick}
          variant="clear-light"
        />
      </div>
    </div>
  );
};
